export const ADD_TO_CART = "ADD_TO_CART";
export const INCREASE_CART_QUANTITY = "INCREASE_CART_QUANTITY";
export const REMOVE_FROM_CART = "REMOVE_FROM_CART";
export const SAVE_CUSTOMER_ADDRESS = "SAVE_CUSTOMER_ADDRESS";
export const RESET_CART = "RESET_CART";
